module.exports = __webpack_public_path__ + "static/media/Mona.9e420308.png";